import styled, { css } from 'styled-components/macro'
import { Swiper } from 'swiper/react'

import { Overlay, styleReset } from 'styles/misc'
import { mq } from 'styles/mq'
import { motion } from 'framer-motion'

export const SliderContainer = styled.div`
  margin: 0 0 3rem;
  overflow: hidden;

  ${mq.large} {
    .swiper {
      overflow: visible;
      background: var(--background);

      &::before,
      &::after {
        content: '';
        position: absolute;
        bottom: 100%;
        left: 0;
        display: block;
        width: 20%;
        height: 5rem;
        mask: linear-gradient(to top, black, transparent);
        pointer-events: none;
        background: var(--background);
        z-index: 10000;
      }

      &::after {
        bottom: auto;
        top: 100%;
        mask: linear-gradient(to bottom, black, transparent);
      }
    }
  }
`

export const Navigation = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 3rem;

  ${mq.smallOnly} {
    flex-wrap: wrap;
  }
`

export const NavButton = styled.button`
  ${styleReset}
  display: flex;
  align-items: center;
  margin: 0 2rem;
  width: 6rem;
  padding-right: 2rem;
  transition: padding 0.3s;

  &::before {
    content: '';
    display: block;
    flex: 1;
    margin: 0 -0.8rem;
    border-top: 2px solid;
  }

  ${mq.smallOnly} {
    width: 5rem;
    order: -1;

    &::before {
      border-top-width: 1px;
    }
  }

  &:first-child {
    padding-left: 2rem;
    padding-right: 0;
    flex-direction: row-reverse;
  }

  &:disabled {
    opacity: 0.3;
  }

  &:not(:disabled) {
    cursor: pointer;

    ${mq.medium} {
      &:hover {
        padding: 0;
      }
    }
  }
`

export const Title = styled(motion.h3)<{ $capitalize?: boolean }>`
  font-size: 2rem;
  line-height: 1.3;
  font-weight: 700;
  margin: 0 auto;
  text-align: center;

  ${props =>
    props.$capitalize &&
    css`
      text-transform: uppercase;
    `}

  ${mq.medium} {
    font-size: 2.5rem;
  }

  ${mq.large} {
    font-size: 3.2rem;
  }
`

export const NavTitle = styled(Title)<{
  $noHyphens?: boolean
  $smallTitle?: boolean
}>`
  font-size: 2rem;
  min-width: ${props => (props.$smallTitle ? '3em' : '11.5em')};
  margin-bottom: -0.1em;

  ${mq.medium} {
    font-size: 2.5rem;
  }

  ${mq.large} {
    font-size: 3.2rem !important;
  }

  ${props =>
    props.$noHyphens &&
    css`
      hyphens: none;
    `}
`

export const NavTitleContainer = styled(motion.div)<{
  $smallTitle?: boolean
}>`
  ${mq.smallOnly} {
    ${props =>
      props.$smallTitle
        ? css`
            order: -1;
          `
        : css`
            margin-top: 0.6em;
          `}
  }
`

export const Description = styled(motion.div)`
  margin: 0 auto;
  max-width: 20em;
  text-align: center;
  font-size: 2.1rem;

  ${mq.smallOnly} {
    font-size: 1.2rem;
    line-height: 1.5;
  }
`

export const StyledSwiper = styled(Swiper)`
  .swiper-wrapper {
    align-items: center;
  }

  .swiper-slide {
    position: relative;
    width: max-content;
  }
`

export const ImageBackdrop = styled(motion.button)`
  ${styleReset}
  ${Overlay}
  position: fixed;
  cursor: pointer;
  opacity: 0.8;
  background-color: var(--background-color);
  z-index: 1000;

  &::before,
  &::after {
    content: '';
    display: block;
    position: absolute;
    height: 3rem;
    border-left: 3px solid currentColor;
    top: 1.8rem;
    right: 3.5rem;
    transform: rotateZ(45deg);
  }

  &::after {
    transform: rotateZ(-45deg);
  }
`

export const ImagePopup = styled(motion.img)`
  display: block;
  position: fixed;
  top: 10vh;
  left: 10vw;
  width: 80vw;
  height: 80vh;
  object-fit: contain;
  pointer-events: none;
  filter: drop-shadow(0 5px 10px rgba(0, 0, 0, 0.2));
  z-index: 1001;
`
